module.exports = __webpack_public_path__ + "fonts/0ea6f69.woff";